import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/LanguageSelector.css';

const languages = [
  { code: 'fr', flag: '🇨🇭', label: 'FR' },
  { code: 'en', flag: '🇬🇧', label: 'EN' },
  { code: 'de', flag: '🇩🇪', label: 'DE' },
  { code: 'zh', flag: '🇨🇳', label: 'ZH' }
];

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const currentLang = languages.find(l => l.code === i18n.language) ||
    languages.find(l => l.code === i18n.language?.split('-')[0]) ||
    languages[0];

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    if (open) document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  const changeLang = (code) => {
    i18n.changeLanguage(code);
    document.documentElement.lang = code;
    setOpen(false);
  };

  return (
    <div className="lang-selector" ref={ref}>
      <button className="lang-selector__btn" onClick={() => setOpen(!open)}>
        <span className="lang-selector__flag">{currentLang.flag}</span>
        <span className="lang-selector__label">{currentLang.label}</span>
      </button>
      {open && (
        <div className="lang-selector__dropdown">
          {languages.map(lang => (
            <button
              key={lang.code}
              className={`lang-selector__option ${lang.code === currentLang.code ? 'active' : ''}`}
              onClick={() => changeLang(lang.code)}
            >
              <span className="lang-selector__flag">{lang.flag}</span>
              <span>{lang.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
